import React, { useEffect, useMemo, useState } from 'react';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import { Button, Col, DatePicker, Empty, Form, notification, Row, Select, Space, Modal, Tag, Descriptions, Checkbox, List } from 'antd';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import StepNoItem from '../../../helpers/components/step_no_item';
import parkService from '../../../services/config/park.service';
import GenerateConsolidateTicketList from './generate_consolidate_ticket_list';
import serviceHelper from '../../../helpers/functions/service.helper';
import { useHistory } from 'react-router-dom';
import GenerateConsolidateConfigDetail from './generate_consolidate_config_detail';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import numberHelper from '../../../helpers/functions/number.helper';
import GenerateConsolidateConfirmation from './generate_consolidate_confirmation';
import FilterBullet from '../../../helpers/components/filter_bullet';
import { CaretDownFilled } from '@ant-design/icons';
import otherService from '../../../services/config/other.service';

const { confirm } = Modal;
const { RangePicker } = DatePicker;
const GenerateConsolidateLayout = ({ default_filter, }) => {
    const { innerWidth } = window;
    const history = useHistory();
    const [form] = Form.useForm();
    const [state, setState] = useState({
        loading : false,
        submit_loading : false,
        is_config : false,
        refresh : 0,

        // filter item list
        parks : [],
        purchase_types : [],
    })

    const [filter, setFilter] = useState({
        park_id : null,
        start_date : null,
        end_date : null,
        purchase_type_ids : null,
    })

    const selected_park = useMemo(() => {
        return state?.parks?.find(x => x?.park_id === filter?.park_id);
    }, [filter?.park_id, state?.parks])

    const setIsConfigured = (is_config) => {
        setState(state => ({...state, is_config, }))
    }

    const confirmSubmitConsolidate = async () => {
        const { park : park_id, ticket_ids = [], } = (form?.getFieldsValue());
        confirm({
            title : `Submit Consolidate Invoice?`,
            okButtonProps : {
                type : 'primary',
            },
            content : (
                <>
                    <div>
                        <GenerateConsolidateConfirmation
                        park={selected_park}
                        ticket_ids={ticket_ids}
                        // is_all={state?.is_select_all}
                        // filter={filter}
                        />
                    </div>
                </>
            ),
            onOk(){
                return new Promise(async (resolve, reject) => {
                    setState(state => ({...state, submit_loading : true, }));
                    const { submit_document, errors, } = await submitConsolidateInvoices();
                    submit_document && resolve();
                    errors?.length && reject();

                    setState(state => ({...state, submit_loading : false, refresh : (state?.refresh + 1), }));
                    form.setFieldsValue({ ticket_ids : [], });
                }).catch(err => {
                    console.error(err);
                })
            },
            // style: {top : 20,},
            width : 800,
        })
    }

    const submitConsolidateInvoices = async () => {
        
        const { park : park_id, ticket_ids = [], } = (form?.getFieldsValue());

        // submit consolidate invoice
        const submitConsolidateInvoiceResponse = await myinvoisTransService?.submitConsolidateInvoiceDocument({
            ticket_ids,
            park_id,
            document_type : "01",
            // FOR CONSOLIDATE ONLY
            form_value : {
                id_type : 2,
                name : "General Public",
                identification_number : "NA",
                tin : "EI00000000010",
                address_line : "NA",
                postal_zone : "NA",
                state : "10",
                city : "NA",
            },
        })?.catch(err => setState(state => ({...state, submit_loading : false, })))
        
        const { submit_document, errors, } = submitConsolidateInvoiceResponse ?? {};

        if(errors?.length > 0){
            notification?.warning({
                description : errors?.[0],
                message : "Oops!",
            });
        }
        else{
            // show notification
            notification.success({
                message : 'Successful generated consolidate e-invoice',
                description : (
                    <>
                        <a style={{color:'var(--main-color)'}} onClick={() => history.push(`/myinvois?search=${submit_document?.response?.submissionUid}`)}>
                            {submit_document?.response?.submissionUid}
                        </a>
                    </>
                ),
                duration: 10,
                placement : 'bottomLeft'
            })
        }

        return { submit_document, errors, };
    }

    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = default_filter ?? {};
        generate_filter[key] = value;
        
        setFilter(filter => ({...filter, ...generate_filter, page : 1,}));
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    const fetchDetail = async () => {
        setState(state => ({...state, loading : true}));
        const parkResponse = await parkService?.getParkByAuth();
        const purchaseTypeResponse = await otherService.getPurchaseTypes();

        const { parks } = parkResponse;
        const { purchase_types, } = purchaseTypeResponse;
        setState(state => ({...state, loading : false, parks, purchase_types, }));
    }

    useEffect(() => {
        fetchDetail();
    }, [])
    
    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign:'start'}}>
                    <PageHeaderComponent isBack title={'Generate Consolidate Invoice'} />
                </div>

                <Form
                // onFinish={submitConsolidateInvoices}
                onFinish={confirmSubmitConsolidate}
                form={form}
                layout={'vertical'}
                >
                    <Space size={24} direction='vertical' style={{ width : '100%', }}>
                        <EntranceMotion>
                            <div style={{textAlign:'start', border:'2px solid #cbd5e0', borderRadius:8, background:'#f7fafc', padding : 24,}}>
                                <Row gutter={[12, 12]}>
                                    <Col span={12}>
                                        <div>
                                            <Form.Item
                                            name="park" 
                                            label={
                                                <StepNoItem no={1}
                                                text={<span style={{fontSize:14, fontWeight:500, color:'var(--secondary-text-color)'}}>Park</span>} 
                                                />
                                            }
                                            >
                                                <Select
                                                onChange={(park_id) => changeFilter("park_id", park_id)}
                                                // value={state?.selected_park_id}
                                                placeholder={'Select Park'}
                                                options={state?.parks?.map((park, index) => {
                                                    const { park_id, name, } = park;
                                                    return {
                                                        value : park_id,
                                                        label : name,
                                                    }
                                                })}
                                                />
                                            </Form.Item>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                        name="payment_date_range" 
                                        label={
                                            <StepNoItem no={2}
                                            text={<span style={{fontSize:14, fontWeight:500, color:'var(--secondary-text-color)'}}>Payment Date Range</span>} 
                                            />
                                        }
                                        >
                                            <RangePicker
                                            onChange={(date, date_strings = [], a) => {
                                                changeFilter("start_date", date_strings?.[0]);
                                                changeFilter("end_date", date_strings?.[1]);
                                            }}
                                            style={{ width : '100%', }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </EntranceMotion>

                        {/* Panel showing myinvois config */}
                        {
                            filter?.park_id && (filter?.start_date && filter?.end_date) ? (
                                <>
                                    <div>
                                        <EntranceMotion key={filter?.park_id}>
                                            <GenerateConsolidateConfigDetail
                                            setIsConfigured={setIsConfigured}
                                            park_id={filter?.park_id}
                                            />
                                        </EntranceMotion>
                                    </div>
                                    <div>
                                        {
                                            state?.is_config && (
                                                <>
                                                    {/* Filter Panel */}
                                                    <div className='filter-panel' style={{textAlign:'start'}}>
                                                        <Space direction={innerWidth > 768 ? 'horizontal' : 'vertical'}>
                                                            <FilterBullet
                                                            popover={
                                                                <>
                                                                    <Checkbox.Group
                                                                    // disabled={ticketRedux?.list_loading}
                                                                    value={filter?.purchase_type_ids}
                                                                    onChange={(checkedValues) => changeFilter('purchase_type_ids', checkedValues)}
                                                                    // onChange={(checkedValues) => onCheckChange('purchase_types', checkedValues)}
                                                                    >
                                                                        <List
                                                                        style={{ width:280, }}
                                                                        dataSource={state?.purchase_types}
                                                                        renderItem={(item, index) => {
                                                                            const { purchase_type_id, name, } = item ?? {};
                                                                            return (
                                                                                <List.Item style={{width:'100%'}} key={index}>
                                                                                    <div style={{display:'flex', alignItems:'center', width:'100%'}}>
                                                                                        <div>
                                                                                            <span>{name}</span>
                                                                                        </div>
                                                                                        <div style={{marginLeft:'auto'}}>
                                                                                            <Checkbox
                                                                                            value={purchase_type_id}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </List.Item>
                                                                            )
                                                                        }}
                                                                        />
                                                                    </Checkbox.Group>
                                                                </>
                                                            }
                                                            >
                                                                <div>
                                                                    <Space>
                                                                        <div>
                                                                            <span>Purchase Types {filter?.purchase_type_ids?.length > 0 ? `: ${filter?.purchase_type_ids?.length}` : ''}</span>
                                                                        </div>
                                                                        <div>
                                                                            <CaretDownFilled style={{color:'#a0aec0'}} />
                                                                        </div>
                                                                    </Space>
                                                                    
                                                                </div>
                                                            </FilterBullet>
                                                        </Space>
                                                    </div>
                                                    
                                                    <div style={{ marginTop : 12, }}>
                                                        <EntranceMotion delay={0.1} key={filter?.park_id}>
                                                            <GenerateConsolidateTicketList
                                                            refresh={state?.refresh}
                                                            // selectAll={selectAll}
                                                            filter={filter}
                                                            form={form}
                                                            is_select_all={state?.is_select_all}
                                                            />
                                                        </EntranceMotion>
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                </>
                            )
                            :
                            (
                                <>
                                    <div>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Please select park and payment date range" />
                                    </div>
                                </>
                            )
                        }

                        <div style={{ display:'flex', }}>
                            <div style={{marginLeft:'auto'}}>
                                <Form.Item>
                                    <Space>
                                        <Button onClick={() => history?.goBack()}>
                                            <span>Cancel</span>
                                        </Button>
                                        <Button disabled={!(filter?.park_id && state?.is_config)} onClick={() => form?.submit()} type="primary" style={{fontWeight:500, padding:'0 24px'}}>
                                            <span>Continue</span>
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </div>
                        </div>
                    </Space>
                </Form>
            </div>
        </>
    );
}

export default GenerateConsolidateLayout;